import { ArcadePage, type ArcadeSpec } from "./ArcadeShell";
import { tk } from "../../../../lib/i18n";

const SPEC: ArcadeSpec = {
  id: "jetski", title: tk("Jetski Kuiz"), tone: "from-sky-500 to-blue-700", emoji: "🌊", w: 360, h: 520, mascot: true, speak: true,
  intro: tk("Tunggang jetski bersama Harraz atau Hannah di sungai bandar! Lalu gelang jawapan yang betul untuk nitro. Elak pelampung dan bot, lompat kayu balak."),
  hint: tk("Sentuh kiri, tengah atau kanan untuk tukar lorong. Leret ke atas untuk lompat."),
  topics: [{ id: "semua", label: tk("Semua subjek") }, { id: "mat", label: tk("Matematik") }, { id: "sains", label: tk("Sains") }, { id: "bm", label: tk("Bahasa Melayu") }, { id: "bi", label: tk("Bahasa Inggeris") }],
  noteLabel: tk("Laju"),
  load: async () => (await import("./engines/jetski3d")).createJetski3d,
};
export const JetskiKuizPage = () => <ArcadePage spec={SPEC} />;
